// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2-DYT","errors":"Errors_errors__2EQTD"};